/* tslint:disable */
/* eslint-disable */
/**
 * The Thing API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ProductionFile,
    ProductionFileFromJSON,
    ProductionFileFromJSONTyped,
    ProductionFileToJSON,
    ProductionInfo,
    ProductionInfoFromJSON,
    ProductionInfoFromJSONTyped,
    ProductionInfoToJSON,
} from './';

/**
 * 
 * @export
 * @interface ProductionSet
 */
export interface ProductionSet {
    /**
     * 
     * @type {string}
     * @memberof ProductionSet
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductionSet
     */
    documentId?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductionSet
     */
    caseId?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductionSet
     */
    batesNumberPrefix?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ProductionSet
     */
    batesNumberStart?: number;
    /**
     * 
     * @type {Date}
     * @memberof ProductionSet
     */
    downloadedDate?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof ProductionSet
     */
    createdDate?: Date;
    /**
     * 
     * @type {boolean}
     * @memberof ProductionSet
     */
    isArchived?: boolean;
    /**
     * 
     * @type {Array<ProductionFile>}
     * @memberof ProductionSet
     */
    productionFiles?: Array<ProductionFile> | null;
    /**
     * 
     * @type {ProductionInfo}
     * @memberof ProductionSet
     */
    productionInfo?: ProductionInfo;
}

export function ProductionSetFromJSON(json: any): ProductionSet {
    return ProductionSetFromJSONTyped(json, false);
}

export function ProductionSetFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProductionSet {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'documentId': !exists(json, 'documentId') ? undefined : json['documentId'],
        'caseId': !exists(json, 'caseId') ? undefined : json['caseId'],
        'batesNumberPrefix': !exists(json, 'batesNumberPrefix') ? undefined : json['batesNumberPrefix'],
        'batesNumberStart': !exists(json, 'batesNumberStart') ? undefined : json['batesNumberStart'],
        'downloadedDate': !exists(json, 'downloadedDate') ? undefined : (json['downloadedDate'] === null ? null : new Date(json['downloadedDate'])),
        'createdDate': !exists(json, 'createdDate') ? undefined : (new Date(json['createdDate'])),
        'isArchived': !exists(json, 'isArchived') ? undefined : json['isArchived'],
        'productionFiles': !exists(json, 'productionFiles') ? undefined : (json['productionFiles'] === null ? null : (json['productionFiles'] as Array<any>).map(ProductionFileFromJSON)),
        'productionInfo': !exists(json, 'productionInfo') ? undefined : ProductionInfoFromJSON(json['productionInfo']),
    };
}

export function ProductionSetToJSON(value?: ProductionSet | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'documentId': value.documentId,
        'caseId': value.caseId,
        'batesNumberPrefix': value.batesNumberPrefix,
        'batesNumberStart': value.batesNumberStart,
        'downloadedDate': value.downloadedDate === undefined ? undefined : (value.downloadedDate === null ? null : value.downloadedDate.toISOString()),
        'createdDate': value.createdDate === undefined ? undefined : (value.createdDate.toISOString()),
        'isArchived': value.isArchived,
        'productionFiles': value.productionFiles === undefined ? undefined : (value.productionFiles === null ? null : (value.productionFiles as Array<any>).map(ProductionFileToJSON)),
        'productionInfo': ProductionInfoToJSON(value.productionInfo),
    };
}


